import { PlayerEvaluationSchema } from '../types/Evaluation';

export const MOCK_PLAYER_EVALUATION: PlayerEvaluationSchema = {
    playerId: 10000,
    playerEvaluationScore: 10,
    playerEvaluationCode: '++',
    evaluationColor: '#333333',
    playerDisplay:"all",
    userNotes:"Top scoring QB for Columbus",
    accountNotes:[{
    note:"Great HS Track & Field Power Shotput",
    createdBy:1,
    createdDate:'2026-01-01',
    },
    { note:"Impressive College Career - Check Game Log",
    createdBy:2,
    createdDate:'2026-02-01',
    }],
    nilContributionsContributed: 0,
    nilContributionsCommitted: 0,
    scholarshipStatus:"Unknown",
    eligibilityRemaining:"Unknown",
    boardCardPrimaryColor:"#000000",
    boardCardSecondaryColor:"#000000",
    customTabs: [
        {
        name: 'Evaluation',
        fields: [
            {
            name: 'Evaluation Role',
            type: 'Singleselect',
            value: 'General Manager',
            selectionMessage: 'Select Role...',
            options: ['General Manager', 'Scout', 'Head Coach', 'Assistant Coach'],
            },
            {
            name: 'Primary Position',
            type: 'Multiselect',
            value: ['QB'],
            selectionMessage: 'Select Position...',
            options: ['QB', 'RB', 'WR', 'TE', 'OL', 'DL', 'LB', 'CB', 'S', 'K', 'P'],
            },
            {
            name: 'Size/Frame',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Grade...',
            options: ['Elite', 'Above Average', 'Average', 'Below Average', 'Poor'],
            },
            {
            name: 'Athletic Ability',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Grade...',
            options: ['Elite', 'Above Average', 'Average', 'Below Average', 'Poor'],
            },
            {
            name: 'Speed',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Grade...',
            options: ['Elite', 'Above Average', 'Average', 'Below Average', 'Poor'],
            },
            {
            name: 'Strength',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Grade...',
            options: ['Elite', 'Above Average', 'Average', 'Below Average', 'Poor'],
            },
            {
            name: 'FB Instincts',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Grade...',
            options: ['Elite', 'Above Average', 'Average', 'Below Average', 'Poor'],
            },
            {
            name: 'Evaluation Notes',
            type: 'Text',
            value: '',
            },
            {
            name: 'Escalate',
            type: 'Boolean',
            value: 'No',
            },
        ],
        },
        {
        name: 'Recruitment',
        fields: [
            {
            name: 'Assigned Coach',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Select a Coach...',
            options: ['Coach Smith', 'Coach Johnson', 'Coach Williams', 'Coach Brown'],
            },
            {
            name: 'Last Contact',
            type: 'Date',
            value: '',
            },
            {
            name: 'Birth Date',
            type: 'Date',
            value: '',
            },
            {
            name: 'Hand Size',
            type: 'Float',
            value: '',
            },
            {
            name: 'Player Strengths',
            type: 'Multiselect',
            value: [],
            selectionMessage: 'Select Strengths...',
            options: ['Leadership', 'Arm Strength', 'Accuracy', 'Mobility', 'Football IQ', 'Pocket Presence'],
            },
            {
            name: 'History',
            type: 'Text',
            value: '',
            },
            {
            name: 'Invited to Camp',
            type: 'Boolean',
            value: 'No',
            },
            {
            name: 'Contact Details',
            type: 'MultipleTexts',
            value: [],
            },
        ],
        },
        {
        name: 'Medical',
        fields: [
            {
            name: 'Medical Status',
            type: 'Singleselect',
            value: '',
            selectionMessage: 'Select Status...',
            options: ['Cleared', 'Limited', 'Out', 'Unknown'],
            },
            {
            name: 'Injury History',
            type: 'Text',
            value: '',
            },
            {
            name: 'Last Physical Date',
            type: 'Date',
            value: '',
            },
            {
            name: 'Weight',
            type: 'Float',
            value: '',
            },
            {
            name: 'Medical Notes',
            type: 'MultipleTexts',
            value: [],
            },
            {
            name: 'Cleared to Play',
            type: 'Boolean',
            value: 'No',
            },
        ],
        },
    ],
};
